// extracted by mini-css-extract-plugin
export default {"toggle-switch":"kVGsOfj","toggle-switch__label":"q45Xlah","toggle-switch__switch-wrapper":"YuZ1nO4","toggle-switch__switch-visual":"yqXJg9j","toggle-switch__input":"ICAKyUe"};